/**
 * MagicEdenCampaignBadge Component
 *
 * Displays a small badge showing "ME 2x" when the user:
 * - Is a Magic Eden $ME staker
 * - Campaign is active
 * - Hasn't exceeded the bonus cap
 *
 * Styled with Magic Eden's pink brand color.
 */

import { useMagicEdenCampaign } from '@/hooks/useMagicEdenCampaign';

// Magic Eden brand color
const ME_COLOR = '#E42575';

export function MagicEdenCampaignBadge() {
  const { campaignData, isLoading } = useMagicEdenCampaign();

  // Only show badge if user is a Magic Eden staker and hasn't reached the cap
  if (isLoading || !campaignData?.isActive || !campaignData?.isMagicEdenStaker || campaignData?.remainingBonus <= 0) {
    return null;
  }

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full"
      style={{
        backgroundColor: 'rgba(228, 37, 117, 0.15)',
        border: `1px solid ${ME_COLOR}`,
      }}
    >
      <img
        src="/Magic Eden.png"
        alt="Magic Eden"
        className="w-3.5 h-3.5 object-contain"
      />
      <span
        className="text-xs font-bold"
        style={{ color: ME_COLOR, fontFamily: 'Outfit, sans-serif' }}
      >
        $ME 2x
      </span>
    </div>
  );
}
